export default "__VITE_ASSET__iljhS9rl__"